export const GROUP_NUMBER = {
	BBI_BROOKSHIRE_BROTHERS: 220,
	ICI_INTERCITY_INVESTMENTS: 188,
	BOP_PANHANDLE_FIRST_BANK: 225,
	PROGRESSIVE_LABORATORIES: 300,
	TEST_GROUP: 999
};
